const th = {
  '赞助和游戏责任': 'การสนับสนุนและความรับผิดชอบในการเล่นเกม',
  '产品': 'ผลิตภัณฑ์',
  '游戏': 'เกม',
  "announcement": 'ดำดิ่งสู่ความตื่นเต้นและสัมผัสกับความสนุกของเกมออนไลน์ของเราวันนี้! สำรวจโลกแห่งโอกาสที่ความสนุกและรางวัลรออยู่แค่เอื้อม!',
  '排名': 'อันดับ',
  "更多的": "เพิ่มเติม",
  "拱廊": "อาเขต",
  "撞车游戏": "เกมชนกัน",
  "钓鱼游戏": "เกมตกปลา",
  "直播": "สด",
  "登录": "เข้าสู่ระบบ",
  "注册": 'ลงทะเบียน',
  "选择语言": 'ภาษา',
  "介绍人": "ผู้อ้างอิง",
  "账号": "บัญชี",
  "密码": "รหัสผ่าน",
  "确认密码": "ยืนยันรหัสผ่าน",
  "真实姓名": "ชื่อจริง",
  "手机号码": "เบอร์โทรศัพท์",
  "取款密码": "รหัสผ่านการถอนเงิน",
  "验证码": "รหัสยืนยัน",
  "请输入密码": "กรุณาใส่รหัสผ่าน",
  "请输入验证码": "กรุณาใส่รหัสยืนยัน",
  "请输入账号": "กรุณาใส่บัญชี",
  "请重新获取验证码": "กรุณารับรหัสยืนยันใหม่อีกครั้ง",
  "正在登录中": "กำลังเข้าสู่ระบบ",
  "网络异常,请稍后再试": "ข้อผิดพลาดของเครือข่าย กรุณาลองใหม่ภายหลัง",
  "账号名": "ชื่อบัญชี",
  "余额": "ยอดเงินคงเหลือ",
  "会员中心": "สมาชิก",
  "网上存款": "ฝากเงินออนไลน์",
  "网上提款": "ถอนเงินออนไลน์",
  "退出": "ออก",
  "请再次输入密码": "กรุณาใส่รหัสผ่านอีกครั้ง",
  "请输入姓名": "กรุณาใส่ชื่อของคุณ",
  "请输入手机号": "กรุณาใส่เบอร์โทรศัพท์",
  "请输入取款密码": "กรุณาใส่รหัสผ่านการถอนเงิน",
  "正在注册中": "กำลังลงทะเบียน",
  "确定": "ยืนยัน",
  "注册成功": "เข้าสู่ระบบสำเร็จ",
  "热门优惠": "ส่วนลดยอดนิยม",
  "首页": "หน้าแรก",
  "查看活动": "ดูกิจกรรม",
  "正在获取活动列表": "กำลังรับรายการกิจกรรม",
  "暂无活动": "ไม่มีกิจกรรมในขณะนี้",
  "活动详情": "รายละเอียดกิจกรรม",
  "视讯直播": "วิดีโอถ่ายทอดสด",
  "直播类型": "ประเภทการถ่ายทอดสด",
  "热门": "ยอดนิยม",
  "推荐": "แนะนำ",
  "最新": "ล่าสุด",
  "全部": "ทั้งหมด",
  "获取类型中": "กำลังรับประเภท",
  "获取具体信息中": "กำลังรับข้อมูลเฉพาะ",
  "开始": "เริ่มต้น",
  "正在获取资源": "กำลังรับทรัพยากร",
  "正在努力加载中": "กำลังพยายามโหลด",
  "电子": "อิเล็กทรอนิกส์",
  "大厅": "ห้องโถง",
  "游戏类型": "ประเภทเกม",
  "游戏标签": "แท็กเกม",
  "错误的类型": "ประเภทที่ผิดพลาด",
  "返回首页": "กลับหน้าแรก",
  "正在获取游戏列表": "กำลังรับรายการเกม",
  "暂无游戏": "ขณะนี้ยังไม่มีเกม",
  "当前未登录,请先登录": "ขณะนี้ยังไม่ได้เข้าสู่ระบบ กรุณาเข้าสู่ระบบก่อน",
  "联系我们": "ติดต่อเรา",
  "导航": "การนำทาง",
  "配置文件信息": "ข้อมูลโปรไฟล์",
  "常用功能": "ฟังก์ชันที่ใช้บ่อย",
  "充值": "เติมเงิน",
  "提现": "ถอนเงิน",
  "功能列表": "รายการฟังก์ชัน",
  "交易": "การทำธุรกรรม",
  "设置": "การตั้งค่า",
  "修改登入密码": "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
  "修改提现密码": "เปลี่ยนรหัสผ่านการถอนเงิน",
  "银行卡": "บัตรธนาคาร",
  "若您先前透由手机号或社交平台登录站点，请您直接联系客服协助设置": "หากคุณเข้าสู่ระบบไซต์ผ่านหมายเลขโทรศัพท์หรือแพลตฟอร์มโซเชียลมีเดียมาก่อน กรุณาติดต่อฝ่ายบริการลูกค้าเพื่อช่วยในการตั้งค่า",
  "旧密码": "รหัสผ่านเก่า",
  "请输入旧密码": "กรุณาใส่รหัสผ่านเก่า",
  "设定新密码": "ตั้งรหัสผ่านใหม่",
  "确认新密码": "ยืนยันรหัสผ่านใหม่",
  "确认": "ยืนยัน",
  "下一步": "ขั้นตอนต่อไป",
  "交易功能": "ฟังก์ชันการซื้อขาย",
  "支付方式": "วิธีการชำระเงิน",
  "充值教学": "การสอนการเติมเงิน",
  "选择渠道": "เลือกช่องทาง",
  "存款金额": "จำนวนเงินฝาก",
  "实际金额": "จำนวนเงินจริง",
  "提现币种": "สกุลเงินที่ถอน",
  "提现银行卡": "บัตรธนาคารสำหรับการถอน",
  "新增": "เพิ่มใหม่",
  "提现金额": "จำนวนเงินถอน",
  "提现金额范围": "ช่วงจำนวนเงินถอน",
  "请输入金额": "กรุณาใส่จำนวนเงิน",
  "实际到帐": "ยอดเงินจริงที่ได้รับ",
  "一般手续费": "ค่าธรรมเนียมทั่วไป",
  "强制手续费": "ค่าธรรมเนียมบังคับ",
  "上一步": "กลับ",
  "修改成功": "แก้ไขสำเร็จ",
  "修改中": "กำลังแก้ไข",
  "拼命加载中": "กำลังโหลดอย่างเร่งด่วน",
  "编辑登录密码": "แก้ไขรหัสผ่านการเข้าสู่ระบบ",
  "编辑提款密码": "แก้ไขรหัสผ่านการถอน",
  "如果您通过手机号码或社交平台登录网站，请联系向客户服务部门寻求帮助。": "หากคุณเข้าสู่เว็บไซต์ผ่านหมายเลขโทรศัพท์หรือโซเชียลมีเดีย โปรดติดต่อฝ่ายบริการลูกค้าเพื่อขอความช่วยเหลือ",
  "请输入新密码": "โปรดป้อนรหัสผ่านใหม่",
  "新密码不能和旧密码一致": "รหัสผ่านใหม่ต้องไม่เหมือนกับรหัสผ่านเก่า",
  "两次输入密码不一致!": "รหัสผ่านทั้งสองที่ป้อนไม่ตรงกัน!",
  "请输入提款密码": "โปรดป้อนรหัสผ่านการถอน",
  "输入提款密码": "ป้อนรหัสผ่านการถอน",
  "请设置新的提款密码": "โปรดตั้งรหัสผ่านการถอนใหม่",
  "设置6位提款密码，并记住您的密码": "ตั้งรหัสผ่านการถอน 6 หลัก และจำรหัสผ่านของคุณ",
  "请输入新的提款密码": "โปรดป้อนรหัสผ่านการถอนใหม่",
  "存款": "ฝากเงิน",
  "取款": "ถอนเงิน",
  "付款方式": "วิธีการชำระเงิน",
  "存款金额": "จำนวนเงินฝาก",
  "请输入金额": "โปรดป้อนจำนวนเงิน",
  "下一步": "ขั้นตอนต่อไป",
  "提款金额": "จำนวนเงินที่ถอน",
  "提款银行卡": "บัตรธนาคารสำหรับถอนเงิน",
  "请输入您的银行卡号": "โปรดป้อนหมายเลขบัตรธนาคารของคุณ",
  "切换语言将会刷新页面": "การเปลี่ยนภาษาจะรีเฟรชหน้า",
  "充值方式": "วิธีการเติมเงิน",
  "取消": "ยกเลิก",
  "登录过期,是否重新登录": "การเข้าสู่ระบบหมดอายุ คุณต้องการเข้าสู่ระบบอีกครั้งหรือไม่",
  "系统提示": "แจ้งเตือนระบบ",
  "国家": "ประเทศ",
  "请输入": "กรุณาใส่",
  "请选择": "กรุณาเลือก",
  "please-select-method": "โปรดเลือกวิธีการชำระเงิน",
  "加载更多": "โหลดเพิ่มเติม",
  "开始": "เริ่ม",
  "存取款": "ฝาก",
  "加钱": "เพิ่มเงิน",
  "选择您的奖金": "เลือกโบนัสของคุณ",
  "100%,最高1500": "100% สูงสุด R$1,500",
  "CASINO": "คาสิโน",
  "Select your lottery": "เลือกหวยของคุณ",
  "don't want a lottery": "ไม่ต้องการหวย",
  "金额不得小于": "จำนวนเงินต้องไม่ต่ำกว่า",
  "金额不得大于": "จำนวนเงินต้องไม่เกิน",
  "加载失败": "โหลดไม่สำเร็จ",
  "活动中心": "ศูนย์กิจกรรม",
  "**财富攀升-BRL的充值促销**": "**ความมั่งคั่งเพิ่มขึ้น - โปรโมชั่นเติมเงินใน BRL**",
  "在这个独特的活动中，我们为您提供了一个积累财富的无尽机会。无论你是初学者还是老手，每次充值都会为你带来不同级别的礼物以及更高级别的特权。": "ในกิจกรรมพิเศษนี้ เรามอบโอกาสในการสะสมความมั่งคั่งให้กับคุณ ไม่ว่าคุณจะเป็นมือใหม่หรือมือเก๋า ทุกครั้งที่เติมเงินจะนำของขวัญระดับต่างๆ และสิทธิพิเศษเพิ่มเติมมาให้คุณ",
  "**青铜级别（青铜）**": "**ระดับบรอนซ์ (บรอนซ์)**",
  "-重新加载的总金额：1.000-5.000 BRL": "- จำนวนการเติมเงินทั้งหมด: 1.000 - 5.000 BRL",
  "-礼品的比例从5%逐渐增加到10%": "- สัดส่วนของขวัญเพิ่มขึ้นจาก 5% เป็น 10%",
  "-第一次充值时，您将收到一份专属礼物。通往财富的大门是敞开的。每充值一次，就会收到更多的礼物。": "- เมื่อคุณเติมเงินครั้งแรก คุณจะได้รับของขวัญพิเศษ ประตูสู่ความมั่งคั่งได้เปิดแล้ว ทุกครั้งที่เติมเงิน คุณจะได้รับของขวัญเพิ่มเติม",
  "**银级（银级）**": "**ระดับเงิน (เงิน)**",
  "-重新加载的总金额：5.001-15.000 BRL": "- จำนวนการเติมเงินทั้งหมด: 5.001 - 15.000 BRL",
  "-礼品的比例从10%逐渐增加到15%": "- สัดส่วนของขวัญเพิ่มขึ้นจาก 10% เป็น 15%",
  "-您已达到白银级别，您的财富将继续增长。充值越多，礼品比例就越高。重新加载更多，赚取更多！": "- คุณได้ถึงระดับเงินแล้ว ความมั่งคั่งของคุณจะเติบโตต่อไป ยิ่งเติมเงินมาก สัดส่วนของขวัญก็จะยิ่งสูง เติมเงินมากขึ้น รับมากขึ้น!",
  "**黄金级别（Gold）**": "**ระดับทอง (ทอง)**",
  "-重新加载的总金额：15.001-30.000 BRL": "- จำนวนการเติมเงินทั้งหมด: 15.001 - 30.000 BRL",
  "-礼品的比例从15%逐渐增加到18%": "- สัดส่วนของขวัญเพิ่มขึ้นจาก 15% เป็น 18%",
  "-你正走在富有的贵族之路上。成为金牌会员后，您将收到更多慷慨的礼物。你的财富注定会兴旺发达。": "- คุณกำลังเดินบนเส้นทางสู่ความมั่งคั่ง ในฐานะสมาชิกทองคำ คุณจะได้รับของขวัญมากมาย ความมั่งคั่งของคุณจะเติบโตอย่างแน่นอน",
  "**白金级别（白金）**": "**ระดับแพลตินัม (แพลตินัม)**",
  "-随着冷却值的增加，会奖励更多的礼物": "- ด้วยการเพิ่มค่าความเย็น จะได้รับของขวัญเพิ่มขึ้น",
  "-重新加载的总金额：30.001-60.000 BRL": "- จำนวนการเติมเงินทั้งหมด: 30.001 - 60.000 BRL",
  "-礼品的比例从18%逐渐增加到20%": "- สัดส่วนของขวัญเพิ่มขึ้นจาก 18% เป็น 20%",
  "-在白金级别，您的充值将获得更高比例的礼物。你的理财能力会变得更加卓越，并获得丰厚的回报。": "- ในระดับแพลตินัม การเติมเงินของคุณจะได้รับสัดส่วนของขวัญที่สูงขึ้น ความเชี่ยวชาญทางการเงินของคุณจะยิ่งโดดเด่น พร้อมรับผลตอบแทนที่มากมาย",
  "**钻石级别（钻石）**": "**ระดับเพชร (เพชร)**",
  "-重新加载的总金额：60.001-100.000 BRL": "- จำนวนการเติมเงินทั้งหมด: 60.001 - 100.000 BRL",
  "-礼品比例最高，达到20%": "- สัดส่วนของขวัญสูงสุดถึง 20%",
  "-这是荣誉的高度，是最终的选择。成为钻石会员后，您将享受最高比例的礼物，使您的财富加速增长，您的财务梦想即将实现。": "- นี่คือระดับเกียรติยศสูงสุด ตัวเลือกที่ดีที่สุด ในฐานะสมาชิกเพชร คุณจะได้รับสัดส่วนของขวัญสูงสุด ความมั่งคั่งของคุณจะเติบโตอย่างรวดเร็ว และความฝันทางการเงินของคุณกำลังจะเป็นจริง",
  "不要错过这个难得的机会。攀登财富的阶梯，看着你的财富成倍增长。加入我们的“财富攀登”BRL补充促销活动，确保为实现您的财务目标提供最佳支持。财富之旅从你开始，回报不会停止增长，成功就在你身边！": "อย่าพลาดโอกาสสุดพิเศษนี้ ปีนบันไดแห่งความมั่งคั่ง ดูความมั่งคั่งของคุณเพิ่มขึ้นหลายเท่า เข้าร่วมโปรโมชั่นเติมเงิน 'Wealth Climbing' ใน BRL ของเรา เพื่อสนับสนุนเป้าหมายทางการเงินของคุณอย่างดีที่สุด การเดินทางสู่ความมั่งคั่งเริ่มต้นที่คุณ ผลตอบแทนไม่หยุดเพิ่มขึ้น ความสำเร็จอยู่ใกล้ตัวคุณ!",
  "游戏记录": "บันทึกเกม",
  "交易记录": "บันทึกธุรกรรม",
  "提交": "ส่ง",
  "游戏品牌": "แบรนด์เกม",
  "游戏名称": "ชื่อเกม",
  "下注时间": "เวลาการเดิมพัน",
  "下注金额": "จำนวนเงินเดิมพัน",
  "输赢金额": "จำนวนเงินที่ชนะหรือแพ้",
  "上一页": "หน้าก่อนหน้า",
  "下一页": "หน้าถัดไป",
  "申请时间": "เวลาการสมัคร",
  "状态": "สถานะ",
  "法规与合作伙伴": "กฎระเบียบและพันธมิตร",
  "为了注册本网站，用户必须接受一般条款和条件。如果条款和条件发生更新，现有用户可以选择在上述更新生效之前停止使用产品和服务，即在更新公布后至少两周。tambet911.com 由JajajEmmi B.V.运营，注册号为150790，地址为Abraham Mendez Chumaceiro Boulevard 03，Willemstad，Curacao。本网站由库拉索岛电子博彩公司许可和监管，许可证号为1668/JAZ。": "เพื่อที่จะลงทะเบียนในเว็บไซต์นี้ ผู้ใช้ต้องยอมรับข้อกำหนดและเงื่อนไขทั่วไป หากมีการอัปเดตข้อกำหนดและเงื่อนไข ผู้ใช้ที่มีอยู่สามารถเลือกหยุดใช้ผลิตภัณฑ์และบริการก่อนที่การอัปเดตดังกล่าวจะมีผล ซึ่งจะต้องประกาศล่วงหน้าอย่างน้อยสองสัปดาห์ Tambet911.com ดำเนินการโดย JajajEmmi B.V. หมายเลขทะเบียน 150790 ที่อยู่ Abraham Mendez Chumaceiro Boulevard 03, Willemstad, Curacao เว็บไซต์นี้ได้รับอนุญาตและควบคุมโดย Curacao Island Electronic Gaming Company ภายใต้หมายเลขใบอนุญาต 1668/JAZ",
  "您可以使用用户名和密码登录": "คุณสามารถเข้าสู่ระบบด้วยชื่อผู้ใช้และรหัสผ่าน",
  "创建账户": "สร้างบัญชี",
  "银行信息": "ข้อมูลธนาคาร",
  "名称": "ชื่อ",
  "时间": "เวลา",
  "最小": "ต่ำสุด",
  "最大": "สูงสุด",
  "即时到账": "ได้รับทันที",
  "选择银行": "เลือกธนาคาร",
  "银行账号": "หมายเลขบัญชีธนาคาร",
  "请输入银行账号": "กรุณาใส่หมายเลขบัญชีธนาคาร",
  "金额": "จำนวนเงิน",
  "支出": "การจ่ายเงิน",
  "输入金额": "กรุณาใส่จำนวนเงิน",
  "暂无数据": "ไม่มีข้อมูลในขณะนี้",
  "获奖人": "ผู้ชนะ",
  "游戏榜": "ชาร์ตเกม",
  "新游戏榜": "ชาร์ตเกมใหม่",
  "热门游戏榜": "อันดับเกมยอดนิยม",
  "电子游戏": "เกมอิเล็กทรอนิกส์",
  "主要余额": "ยอดเงินหลัก",
  "历史记录": "ประวัติ",
  "付款名称": "ชื่อการชำระเงิน",
  "费用": "ค่าใช้จ่าย",
  "免费": "ฟรี",
  "立即生效": "มีผลทันที",
  "银行选择": "เลือกธนาคาร",
  "银行账户": "บัญชีธนาคาร",
  "充值金额": "จำนวนเงินเติม",
  "收款名称": "ชื่อผู้รับเงิน",
  "账号类型": "ประเภทบัญชี",
  "收账账号": "หมายเลขบัญชีผู้รับ",
  "CPF号码": "หมายเลข CPF",
  "提现密码": "รหัสผ่านการถอน",
  "请输入名称": "กรุณาใส่ชื่อ",
  "请选择类型": "กรุณาเลือกประเภท",
  "请输入CPF": "กรุณาใส่ CPF",
  "请输入提现金额": "กรุณาใส่จำนวนเงินถอน",
  "请输入正确的参数": "กรุณาใส่พารามิเตอร์ที่ถูกต้อง",
  "收藏夹": "รายการโปรด",
  "敬请期待": "เร็วๆ นี้",
  "用户": "ผู้ใช้",
  "玩家": "ผู้เล่น",
  "时间": "เวลา",
  "赌场": "คาสิโน",
  "体育运动": "กีฬา",
  "促销": "โปรโมชั่น",
  "支持/法律": "สนับสนุน/กฎหมาย",
  "加入我们的社区": "เข้าร่วมชุมชนของเรา",
  "赌场主页": "หน้าหลักคาสิโน",
  "插槽": "สล็อต",
  "现场赌场": "คาสิโนสด",
  "新版本": "เวอร์ชันใหม่",
  "桌面游戏": "เกมบนโต๊ะ",
  "体育之家": "หน้ากีฬา",
  "会员俱乐部": "คลับวีไอพี",
  "优惠促销": "โปรโมชั่น",
  "赌博意识": "ตระหนักถึงการพนัน",
  "常问问题": "คำถามที่พบบ่อย",
  "条款和条件": "ข้อกำหนดและเงื่อนไข",
  "隐私政策": "นโยบายความเป็นส่วนตัว",
  "赞助和游戏责任": "การสนับสนุนและความรับผิดชอบในการเล่นเกม",
  "页脚文本": "BetBlitz มุ่งมั่นที่จะครอบครองความเป็นผู้นำระดับโลกในโลกแห่งเกมออนไลน์และการเดิมพัน โดยใช้เทคโนโลยีบล็อกเชนที่ทันสมัย ​​และให้ความสำคัญกับความพึงพอใจของลูกค้า หลักการที่อยู่เบื้องหลังการดำเนินการของเราคือความไว้วางใจ ความซื่อสัตย์ และความยุติธรรม",
  "充电时间": "เวลาชาร์จ",
  "订单号": "หมายเลขคำสั่งซื้อ",
  "充值金额": "จำนวนเงินเติม",
  "充值方式": "วิธีการเติมเงิน",
  "地位": "สถานะ",
  
  '负责任的博彩': 'การเล่นเกมอย่างมีความรับผิดชอบ',
  '快速链接': 'ลิงก์ด่วน',
  '桌上游戏': 'เกมบนโต๊ะ',
  '二十一点': 'แบล็คแจ็ค',
  '扑克': 'โป๊กเกอร์',
  '百家乐': 'บาคาร่า',
  '掷骰子': 'แครปส์',
  '奖金': 'โบนัส',
  '赌场奖金': 'โบนัสคาสิโน',
  '自由旋转': 'ฟรีสปิน',
  '免费投注': 'เดิมพันฟรี',
  '信息': 'ข้อมูล',

  '老虎机游戏': 'เกมสล็อต',
  '赌场游戏': 'เกมคาสิโน',
  '更多游戏': 'เกมเพิ่มเติม',
  '搜索游戏': 'ค้นหาเกม',
  '特色提供商': 'ผู้ให้บริการแนะนำ',
  'Logout': 'ออกจากระบบ',
  'Personal Center': 'ศูนย์ส่วนตัว',
  'Limit': 'ขีดจำกัด',
  'MessageCenter': 'ศูนย์ข้อความ',

  'All': 'ทั้งหมด',
  'Arcade': 'อาเขต',
  'Bingo': 'บิงโก',
  'Card': 'การ์ด',
  'Casino': 'คาสิโน',
  'Crash': 'แครช',
  'Fish': 'เกมตกปลา',
  'Live': 'ถ่ายทอดสด',
  'Lottery': 'ลอตเตอรี่',
  'Slot': 'สล็อต',
  'Sports': 'กีฬา',
  'Video Game': 'วิดีโอเกม',

  'cs-title': 'บริการตลอด 24 ชั่วโมง',
  'cs-text': 'บริการลูกค้าพร้อมให้ความช่วยเหลือและแก้ไขปัญหา',
  'cs-contact': 'ติดต่อ',

  'social-media': 'โซเชียลมีเดีย',
  'contact-us': 'ติดต่อเราผ่านช่องทางต่อไปนี้',

  'footer-line1': 'ดำเนินการโดย',
  'footer-line2': 'ที่อยู่บริษัท',
  'footer-line3': 'ผลิตภัณฑ์นี้ใช้สำหรับผู้ที่มีอายุ 18 ปีขึ้นไปเท่านั้น และใช้เพื่อความบันเทิงเท่านั้น',
  'footer-line4': 'เกมนี้มีการซื้อในแอป',
  'footer-line5': 'การที่ผู้เล่นเล่นหรือชนะในการเล่นเกมทางสังคมไม่ได้หมายความว่าพวกเขาจะชนะในการเล่นการพนันเงินจริงหรือเกมที่เกี่ยวข้องในอนาคต',

  'popup-message': 'คุณต้องการปิดการแจ้งเตือนหรือไม่?',

  'sign-in': 'เข้าสู่ระบบ',
  'password': 'รหัสผ่าน',
  'confirm-password': 'ยืนยันรหัสผ่าน',
  'remember-me': 'จดจำฉัน',
  'forgot-password': 'ลืมรหัสผ่าน',
  'sign-in-note': 'ยังไม่มีบัญชี?',
  'register-note': 'มีบัญชีแล้ว?',
  'register': 'ลงทะเบียน',

  'popular': 'ยอดนิยม',
  'promotion': 'โปรโมชั่น',
  'follow': 'ติดตาม',
  'search': 'ค้นหา',

  'home': 'หน้าหลัก',
  'deposit': 'ฝากเงิน',
  'withdraw': 'ถอนเงิน',
  'profile': 'โปรไฟล์',
  'online-cs': 'บริการลูกค้าออนไลน์',

  'search-games': 'ค้นหาเกม',
  'search-results': 'ผลการค้นหา',

  'Activity': 'กิจกรรม',
  'Rebates': 'เงินคืน',
  'VIP': 'วีไอพี',
  'History': 'ประวัติ',
  'Cover': 'ครอบคลุม',

  'recharge-activity': 'กิจกรรมการเติมเงิน',
  'time': 'เวลา',
  'reward': 'รางวัล',
  'deposit-value': 'มูลค่าการฝาก',
  'status': 'สถานะ',
  'reward-bonus-discription': 'รับฟรี 10R$ หลังจากการฝากครั้งแรกของคุณที่ 100R$',
  'invitaion-activity-discription': 'เชิญเพื่อนและรับฟรี 100R$',
  'daily-loss-activity-discription': 'เงินคืนรายวัน 8%',
  'recharge-rebet-activity-discription': 'รับเงินคืน 20% ฟรีเมื่อคุณเติมเงิน 100R$ ในธุรกรรมเดียว',
  'user-not-eligible': 'คุณไม่มีสิทธิ์รับรางวัลนี้',
  '不符合领取资格': 'ไม่มีสิทธิ์รับรางวัล',
  'reward-claimed': 'รับรางวัลสำเร็จ!',
  '没有符合资格的充值': 'ไม่มีการเติมเงินที่มีสิทธิ์',

  'invitation-activity':'กิจกรรมเชิญชวน',
  'recharge-amount':'จำนวนการเติมเงิน',
  'spin':'หมุน',
  'bonus':'โบนัส',
  'invites':'การเชิญชวน',
  "install-btn": "ติดตั้ง",

  'daily-loss-relief-fund':'กองทุนบรรเทาการสูญเสียรายวัน',
  'percent':'เปอร์เซ็นต์',
  "amount-loss": "จำนวนการสูญเสีย",

  'recharge-rebate-activity':'กิจกรรมคืนเงินการเติมเงิน',
  'recharge-amount':'จำนวนการเติมเงิน',
  'return-ratio':'อัตราการคืนเงิน',
  'return-amount':'จำนวนเงินที่คืน',

  'recharge-note1':'เติมเงินครั้งเดียว 100 เรียลบราซิลสามารถเข้าร่วมกิจกรรมได้',
  'recharge-note2':'แต่ละการเติมเงิน 100 เรียลบราซิลขึ้นไปคำนวณแยกกัน',
  'recharge-note3':'กิจกรรมนี้ต้องมีจำนวนการเติมเงินขั้นต่ำ 5 เท่าของการเติมเงินเพื่อรับรางวัล',
  'recharge-note4':'ผู้ที่ไม่ผ่านเกณฑ์หรือรับรางวัลหลังจากสิ้นสุดกิจกรรมจะไม่สามารถรับรางวัลได้อีก',
  'recharge-note5':'หลีกเลี่ยงการสูญเสีย กรุณาทำงานให้เสร็จล่วงหน้าหรือรับรางวัล',
  'recharge-note6':'กิจกรรมนี้จำกัดเฉพาะพฤติกรรมการใช้งานบัญชีตามปกติ ห้ามใช้วิธีทางเทคนิค เช่น การเช่า การโกง บอท การเล่นเกมด้วยบัญชีต่าง ๆ การแปรงกัน การตัดสิน การใช้ช่องโหว่ และการควบคุมกลุ่ม มิฉะนั้นจะถูกยกเลิกรางวัล ยึดคืน แช่แข็ง หรือแม้กระทั่งขึ้นบัญชีดำ',
  'recharge-note7':'สิทธิ์การตีความของกิจกรรมทั้งหมดเป็นของแพลตฟอร์มนี้โดยสมบูรณ์',

  'claim':'รับรางวัล',

  'lottery-wheel':'วงล้อหวย',
  'number-of-spin':'จำนวนการหมุน',
  'spin':'หมุน',

  'upgrade-required':'ต้องการการอัปเกรด',
  'recharge':'เติมเงิน',
  'betting':'การเดิมพัน',
  'Bonus':'โบนัส',
  'Notification':'การแจ้งเตือน',
  'Announcement':'ประกาศ',
  'Support':'สนับสนุน',
  'level':'ระดับ',

  'view-data':'ดูข้อมูล',
  'current-data':'ข้อมูลปัจจุบัน',
  'last':'ล่าสุด',
  'days':'วัน',
  'event':'กิจกรรม',
  'notes':'หมายเหตุ',

  'rebate-funds':'เงินคืน',
  'statement':'แถลงการณ์',
  'rebate':'คืนเงิน',

  'platform-rebate':'คืนเงินจากแพลตฟอร์ม',
  'action':'การกระทำ',
  'type':'ประเภท',
  'amount':'จำนวน',

  'record':'บันทึก',
  'recharge-method': 'วิธีการเติมเงิน',
  'recharge-note':'หากคุณพบปัญหาใด ๆ โปรดติดต่อเรา!',
  'withdrawal-note':'หากคุณพบปัญหาใด ๆ โปรดติดต่อเรา!',
  'online-service':'บริการออนไลน์',
  'recharge-amount': 'จำนวนการเติมเงิน',
  'withdrawal':'การถอนเงิน',
  'online-withdrawal':'การถอนเงินออนไลน์',
  'withdrawal-method':'วิธีการถอนเงิน',
  'fee':'ค่าธรรมเนียม',
  'full-name':'ชื่อเต็ม',
  'please-enter-your':'กรุณาใส่ของคุณ',
  'name':'ชื่อ',
  'collection-account-number':'หมายเลขบัญชีผู้รับ',
  'withdraw-password':'รหัสผ่านการถอน',
  'phone-number':'หมายเลขโทรศัพท์',
  'security-center':'ศูนย์รักษาความปลอดภัย',
  'change-password':'เปลี่ยนรหัสผ่าน',
  'financial-status':'สถานะการเงิน',
  'verify-password':'ยืนยันรหัสผ่าน',
  'bind-email-note':'คุณกำลังผูกอีเมลและต้องยืนยันรหัสผ่านการเข้าสู่ระบบ',
  'bind-password-note':'คุณกำลังเปลี่ยนรหัสผ่านและต้องเข้าสู่ระบบเพื่อยืนยันรหัสผ่าน',
  'next-step':'ขั้นตอนถัดไป',

  'balance':'ยอดคงเหลือ',
  'information-center':'ศูนย์ข้อมูล',
  'order-center':'ศูนย์คำสั่ง',
  'agency-center':'ศูนย์ตัวแทน',
  'exit':'ออก',
  'bonus-amount':'จำนวนโบนัส',
  'fee-amount':'จำนวนค่าธรรมเนียม',
  'change': 'เปลี่ยน',
  'male':'ชาย',
  'female':'หญิง',
  'submit':'ส่ง',
  'information':'ข้อมูล',
  'Details':'รายละเอียด',
  'Fee':'ค่าธรรมเนียม',
  'Association':'สมาคม',

  'Invite':'เชิญ',
  'Agent':'ตัวแทน',
  'Invitation record':'บันทึกการเชิญ',
  'Invitation':'การเชิญ',
  'Reward':'รางวัล',
  'Agency mechanism':'กลไกตัวแทน',
  'Register subordinates':'ลงทะเบียนลูกน้อง',
  'my-id':'ID ของฉัน',
  'inviter-id':'ID ผู้เชิญ',
  'ordinary-agent':'ตัวแทนธรรมดา',
  'my-invitation-information':'ข้อมูลการเชิญของฉัน',
  'my-links':'ลิงก์ของฉัน',
  'save-qr-code':'บันทึก QR โค้ด',
  'my-invitation-record':'บันทึกการเชิญของฉัน',
  'total-number-of-invited-people':'จำนวนคนที่เชิญทั้งหมด',
  'direct-reports':'รายงานตรง',
  'invitation-rewards':'รางวัลการเชิญ',
  'invitation-total-reward':'รางวัลการเชิญทั้งหมด',
  'directly-invite-rewards':'รางวัลการเชิญตรง',
  'indirect-invitation-reward':'รางวัลการเชิญทางอ้อม',
  'more':'เพิ่มเติม',

  'invitation-total':'ยอดการเชิญ',
  'direct-rewards':'รางวัลการเชิญตรง',
  'indirect-incentives':'แรงจูงใจทางอ้อม',
  'no-agent':'ไม่มีตัวแทนที่จะแสดง',
  "no-record": "ไม่พบบันทึก",
  "no-more-roll": "ไม่มีการหมุนเหลืออยู่",
  'rebate-ration':'อัตราส่วนเงินคืน',
  'deposit-value':'มูลค่าการฝาก',

  'bet-on':'เดิมพัน',
  'settlement':'การชำระบัญชี',
  'consumption':'การบริโภค',
  'agent-text':'ข้อความตัวแทน',
  'reg-sub-text':"หลังจากลงทะเบียนเสร็จแล้ว ให้ใส่หมายเลขโทรศัพท์ที่ลงทะเบียนของผู้เชิญ รหัสการเชิญ และ UID ของพวกเขาเพื่อผูกข้อมูล",
  'your-invitation-code':'รหัสการเชิญของคุณ',
  'UID-of-the-invitee':'UID ของผู้เชิญ',
  'user-does-not-exist':'ผู้ใช้ไม่มีอยู่',

  'no-record':'ไม่พบบันทึก',
  'reg-success':'การลงทะเบียนของคุณสำเร็จแล้ว',
  'reg-failed':'การลงทะเบียนล้มเหลว',
  'valid-number':'กรุณาใส่หมายเลขโทรศัพท์ที่ถูกต้อง',
  'valid-pass2':'รหัสผ่านไม่ตรงกัน',
  'pass-error':'รหัสผ่านต้องมีอย่างน้อย 6 อักขระ',  
  "network-error": "เกิดข้อผิดพลาดเครือข่าย กรุณาลองใหม่ภายหลัง",
  'fix-error':'กรุณาแก้ไขข้อผิดพลาดในฟอร์ม',

  'invalid_phone': 'กรุณากรอกหมายเลขโทรศัพท์มือถือที่ถูกต้อง.',
}
export default th



// WEBPACK FOOTER //
// ./src/utils/lang/config/thai.js